import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge36 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='名義書換料の勘定科目・仕訳完全ガイド' fontWeight={700} />
                <p>
                    名義書換料の相場や基本的な性質については
                    <a href='/knowledge/3'>名義書換に関して</a>
                    ですでにご紹介していますが、実務では「どの勘定科目で処理すればよいか」「仕訳をどう起票すればよいか」が悩みどころです。
                    <br />
                    本記事では、法人・個人それぞれの名義書換料の勘定科目と、具体的な仕訳例をご紹介します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='名義書換料の勘定科目は「支払う場面」で決まる' fontWeight={700} />
                <p>名義書換料は、法人税基本通達9-7-11・9-7-13に基づき、支払う場面によって勘定科目が変わります。</p>

                <Heading3 title='新規に法人会員として入会する場合：資産計上' />
                <p>
                    新規に法人会員として入会する際に支払う名義書換料は、入会金・預託金・売買手数料などとあわせてゴルフ会員権の取得価額に含め、資産（投資その他の資産）として計上します。経費として一括で損金算入することはできません。
                </p>

                <Heading3 title='既に法人会員である会員権の名義人を変更する場合：交際費' />
                <p>
                    すでに法人として保有しているゴルフ会員権について、記名されている役員・使用人の異動や退職にともない名義だけを変更する場合、その際に支払う名義書換料は交際費として処理します（入会金を資産計上している場合）。この場合は資産の取得ではなく、既存資産に付随する費用という位置づけになります。
                </p>

                <Heading3 title='特定の役員・使用人が私的に利用している場合：給与' />
                <p>
                    入会金を給与として処理している記名式の法人会員について名義書換をする場合、その名義書換料も同じ人物に対する給与として扱います。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='具体的な仕訳例（法人・税抜経理方式）' fontWeight={700} />

                <Heading3 title='①新規に法人会員として入会し、名義書換料55万円（税込）を支払った場合' />
                <p>
                    （借方）ゴルフ会員権 50万円
                    <br />
                    （借方）仮払消費税等 5万円
                    <br />
                    （貸方）現金預金 55万円
                    <br />
                    <br />
                    新規入会時の名義書換料は、他の取得費用と合算してゴルフ会員権（資産）の取得価額に含めます。
                </p>

                <Heading3 title='②既存会員の記名者変更で名義書換料22万円（税込）を支払った場合' />
                <p>
                    （借方）交際費 20万円
                    <br />
                    （借方）仮払消費税等 2万円
                    <br />
                    （貸方）現金預金 22万円
                    <br />
                    <br />
                    既存の資産計上額を変更する必要はなく、当期の費用として処理します。中小法人の交際費等の損金算入限度額の対象に含まれるため、他の交際費支出との合計額にも注意しましょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='個人が支払う名義書換料の取り扱い' fontWeight={700} />
                <p>
                    個人事業主が事業用としてゴルフ会員権を取得する際に支払う名義書換料は、法人と同様に取得価額に算入し、資産として計上します。
                    <br />
                    給与所得者などが私的な趣味として個人会員に入会する場合は、名義書換料は必要経費にはならず、家計からの支出（消費）として扱われます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='相続・贈与で取得した場合の名義書換料' fontWeight={700} />
                <p>
                    相続や贈与によってゴルフ会員権を取得し、その際に名義書換料を支払った場合、この名義書換料は将来そのゴルフ会員権を売却するときの譲渡所得の計算上、取得費に加算できる場合があります。
                    <br />
                    相続時の名義書換料の位置づけについては
                    <a href='/knowledge/34'>ゴルフ会員権の相続税評価・計算方法（具体例つき）</a>
                    、贈与時については
                    <a href='/knowledge/35'>ゴルフ会員権の贈与（生前贈与時の評価・注意点）</a>
                    でもあわせてご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    名義書換料は、新規入会なら資産計上、既存会員の名義変更なら交際費というのが基本の考え方です。金額も10万円程度から1,000万円を超えるゴルフ場までさまざまで、処理を誤ると税務調査で指摘を受けるリスクもあるため、迷った際は顧問税理士に確認しながら仕訳を起票しましょう。
                    <br />
                    名義書換の手続きや必要書類については<a href='/knowledge/3'>こちら</a>をご覧ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge36;
